module.exports = __webpack_public_path__ + "img/Assustado_Corpo_1.d8d8afec.png";